import React from "react";
import moment from "moment";
import { styled } from "@mui/material/styles";
import { Box, Grid, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
  borderRadius: "20px",
  width: "90%",
  maxWidth: "800px",
};

// const CarDetailsStyle = {
//   overflowY: "scroll",
//   height: 500,
//   width: 600,
// };

const CarDetails = styled(Box)`
  overflow-y: auto;
  height: 300px;
`;

function CarRow({ name, value }) {
  return (
    <Grid container mb={1}>
      <Grid item xs={12} sm={2}>
        {name}
      </Grid>

      <Grid item xs={12} sm={10}>
        {value}
      </Grid>
    </Grid>
  );
}

const EditOfferModal = ({ open, handleClose, selectedCar }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <CloseIcon
          sx={{
            position: "fixed",
            top: 20,
            right: 20,
            cursor: "pointer",
          }}
          onClick={handleClose}
        />

        <Typography
          variant="h6"
          sx={{
            mb: 2,
          }}
        >
          {`${selectedCar.make} - ${selectedCar.modelsText}`}
        </Typography>
        <CarDetails>
          <CarRow name="Make" value={selectedCar.make} />
          <CarRow name="Models Text" value={selectedCar.modelsText} />
          <CarRow name="Offer Text" value={selectedCar.offerText} />
          <CarRow name="Offer Title" value={selectedCar.offerTitle} />
          <CarRow name="car_id" value={selectedCar.car_id || "Not uploaded"} />
          <CarRow name="State" value={selectedCar.state} />
          <CarRow name="Offer Type" value={selectedCar.offerType} />

          <CarRow
            name="From Date"
            value={moment(selectedCar.fromDate).format("MMMM Do YYYY")}
          />
          <CarRow
            name="To Date"
            value={
              selectedCar.toDate
                ? moment(selectedCar.toDate).format("MMMM Do YYYY")
                : "Not Specified"
            }
          />
          <img
            src={`${process.env.REACT_APP_IMAGE_URL}/car-images/${selectedCar.image}`}
            alt="Car"
            style={{
              width: "150px",
              height: "auto",
              borderRadius: "10px",
              marginTop: "10px",
            }}
          ></img>
        </CarDetails>
      </Box>
    </Modal>
  );
};

export default EditOfferModal;
